export default __webpack_public_path__ + "6d335aad482e853acec7d5a33cb87f9e.png";